module.exports = __webpack_public_path__ + "static/media/gn.4456e168.mp3";